import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 py-20 text-center">
      <p className="text-7xl md:text-9xl font-bold text-background-300 select-none">404</p>
      <h1 className="text-xl md:text-2xl font-bold text-foreground-950 mt-4">页面走丢了</h1>
      <p className="text-sm text-foreground-500 mt-2">
        没有找到对应页面：<span className="font-mono text-foreground-700">{location.pathname}</span>
      </p>
      <div className="flex flex-wrap justify-center gap-3 mt-6">
        <Link
          to="/"
          className="px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          去搜索影视
        </Link>
      </div>
    </div>
  );
}